const initialState = {
    leadTypes: [],
    isReadingLeadTypes: false
}

export default initialState;
